import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { ProductModalProductDetailsProductFragmentDoc } from './ProductModalProductDetailsProduct.generated'
import { ProductModalProductPreviewProductFragmentDoc } from './ProductModalProductPreviewProduct.generated'
import * as Types from './purchasePlus_graphql'

export const GetProductModalDocument = gql`
  query GetProductModal($productId: Int!, $supplierId: Int!, $tagFilters: ProductTagsQueryFiltersInput) {
    product(id: $productId) {
      id
      brand
      itemDescription
      owner {
        id
      }
      barcodes {
        totalCount
      }
      substituteProducts {
        totalCount
      }
      productTags(filters: $tagFilters) {
        totalCount
      }
      ...ProductModalProductPreviewProduct
      ...ProductModalProductDetailsProduct
    }
  }
  ${ProductModalProductPreviewProductFragmentDoc}
  ${ProductModalProductDetailsProductFragmentDoc}
` as unknown as DocumentNode<Types.GetProductModalQuery, Types.GetProductModalQueryVariables>
